export default __webpack_public_path__ + "media/images/action3-4c86b6b1a8e56c708d9a2534a7f8262e.png";